<template>
    <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div class="w-full bg-primary rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
            <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
                <h1 class="text-xl text-white font-bold">Login to IT Event Management System</h1>
                <form ref="form">
                    <InputGroup name="email" class="mb-3" label="Email" v-model="email" :reverseColor="true" />
                    <InputGroup name="password" class="mb-6" label="Password" type="password" v-model="password" :reverseColor="true" />
                    <ButtonAccent @click.prevent="login" class="w-full">Login</ButtonAccent>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import EventOrganizer from '../../../src/classes/EventOrganizer';
export default {
    components: {

    },

    data() {
        return {
            email: '',
            password: '',
        };
    },

    methods: {
        async login() {
            const organizer = new EventOrganizer(this);
            const response = await organizer.login(this.email, this.password);

            if (response.result === 'success') {
                this.$refs.form.reset();

                this.saveCredentials({
                    token: response.data.token,
                });

                this.$root.organizer = organizer;

                this.$router.replace('/');
            }
        }
    }
}
</script>